import { render, staticRenderFns } from "./HtmlAnswer.vue?vue&type=template&id=3fa0fbee&scoped=true"
import script from "./HtmlAnswer.vue?vue&type=script&lang=js"
export * from "./HtmlAnswer.vue?vue&type=script&lang=js"
import style0 from "./HtmlAnswer.vue?vue&type=style&index=0&id=3fa0fbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa0fbee",
  null
  
)

export default component.exports